<ng-container *ngIf="!uploading && !connectionFailed && !uploadSuccess">
  <div class="container" [ngClass]="activeLanguage$ | async" *ngIf="data$ | async as data">
    <input type="file" #fileDropRef id="csvFile" (change)="fileBrowseHandler($event)" />
    <mat-icon class="upload" svgIcon="upload"></mat-icon>
    <h3 [innerHTML]="data.title"></h3>
    <label for="csvFile" [innerHTML]="data.shortDescription"></label>
  </div>
</ng-container>
<ng-container *ngIf="uploading && !connectionFailed">
  <div class="container uploading-status">
    <h3 [innerHTML]="'csvImport.uploading' | cxTranslate"></h3>
    <label *ngIf="fileName.length <= 46" [innerHTML]="fileName"></label>
    <app-tooltip-text
      *ngIf="fileName.length > 46"
      class="has-tooltip"
      [tooltipContent]="fileName"
      [content]="fileName"
      placement="bottom"
    ></app-tooltip-text>
  </div>
</ng-container>

<ng-container *ngIf="!uploading && connectionFailed">
  <div class="container uploading-status status failed-container" (dragover)="resetUpload()">
    <h3 class="failed">
      {{ 'csvImport.failed' | cxTranslate }}&nbsp;
      <mat-icon>error</mat-icon>
    </h3>
    <label [innerHTML]="'csvImport.failedSubtext' | cxTranslate" *ngIf="!errorText"></label>
    <label [innerHTML]="errorText" *ngIf="errorText"></label>
    <button class="tertiary-btn btn" (click)="resetUpload()" [innerHTML]="'csvImport.retry' | cxTranslate"></button>
  </div>
</ng-container>

<ng-container *ngIf="!uploading && uploadSuccess">
  <div class="container uploading-status upload-success status" (dragover)="resetUpload()">
    <h3 class="success"><mat-icon>check</mat-icon></h3>
    <h3 class="success" [innerHTML]="'csvImport.success' | cxTranslate"></h3>
    <label *ngIf="fileName.length <= 46" [innerHTML]="fileName"></label>
    <app-tooltip-text
      *ngIf="fileName.length > 46"
      class="has-tooltip"
      [tooltipContent]="fileName"
      [content]="fileName"
      placement="bottom"
    ></app-tooltip-text>
    <button
      class="tertiary-btn btn"
      [routerLink]="['/saved-cart']"
      [innerHTML]="'csvImport.viewSavedCart' | cxTranslate"
    ></button>
  </div>
</ng-container>
